import axios from 'axios'
import { useStore } from "@/store/user";
import { ElMessage, ElNotification } from "element-plus";

const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    withCredentials: false, // 跨域请求时是否需要使用cookie凭证
    timeout: 8000
})

service.interceptors.request.use(
    config => {
        const userStore = useStore();   // 在pinia挂载之前使用会出错，故useStore必须在里面调用
        if (userStore.isLogin) {
            config.headers['Authorization'] = userStore.token;
        }
        return config;
    },
    error => {
        ElNotification({
          title: '错误',
          message: error.message,
          type: 'error',
        });
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
  response => {
      const res = response.data;
      if (res.status !== 0) {
          ElNotification({
              title: '错误',
              message: res.msg || '未知错误',
              type: 'error',
          });
          // return Promise.reject(new Error(res.message || 'Error'));
          return Promise.reject(new Error(res.msg || '未知错误'));
      } else {
          if (res.msg != null) {
              ElMessage({
                  showClose: true,
                  message: res.msg,
                  type: 'success',
              });
          }
          return res.data;
      }
  },
)

export default service
